export const developerModules = [
    {
        subtitle: "Intro to the Terminal",
        text: `
            Learn essential terminal basics including the terminal prompt, basic commands, navigation, getting help, and command options. This module provides the fundamental knowledge needed to interact with the Linux command line effectively.
        `,
    },
    {
        subtitle: "Manipulating Files and Directories",
        text: `
            Learn essential file and directory operations in Linux. Topics include file management basics, viewing file contents, comparing files, creating hard and soft links, archiving and compression, file metadata management, efficient file searching, and safe deletion practices. Develop practical skills for organizing and manipulating your file system.
        `,
    },
    {
        subtitle: "Text Processing",
        text: `
            Learn text processing tools like grep, sed, cut, and wc to search, filter, and manipulate text files. Covers redirection, pipes, sorting, and processing structured data formats like JSON and YAML. Essential skills for log analysis, data processing, and system administration.
        `,
    },
    {
        subtitle: "Advanced Shell Features",
        text: `
            Learn command substitution, shell variables, glob expansion, exit status handling, and shell customization through aliases and functions. Topics include creating command shortcuts, handling command outputs, and writing shell scripts with error handling and pattern matching.
        `,
    },
    {
        subtitle: "Permissions and Access Control",
        text: `
            Learn Linux security with comprehensive coverage of file permissions, ownership, and access control. Covers user and group management, modifying permissions with chmod/chown/chgrp, special permission bits (SUID, SGID, sticky bits), and using sudo/su for privilege management. Essential for system security and administration.
        `,
    },
    {
        subtitle: "Process Management",
        text: `
            Learn Linux process management with essential commands like ps, top, and kill. Covers process monitoring, signals, environment variables, and daemon processes. Develop skills in background job management, process control, and system administration fundamentals.
        `,
    },
    {
        subtitle: "Networking",
        text: `
            Learn essential networking tools and concepts. Covers network basics, troubleshooting with ping and netcat, secure remote access with SSH, file transfers using SCP, and web interactions with curl and wget. Includes advanced topics like API usage and secure file transfers.
        `,
    },
    {
        subtitle: "Text Editing in the Terminal",
        text: `
            Learn terminal-based text editing with both nano and vim. Covers nano's user-friendly interface for quick edits, and vim's features for text manipulation. Includes navigation, editing, saving, and advanced usage of both editors. Essential skills for system administration and development.
        `,
    },
    {
        subtitle: "Package Management",
        text: `
            Learn package management on Ubuntu using both APT and dpkg. Covers installing, updating, removing, and searching for packages. Understand system maintenance, package dependencies, and repository management. Essential skills for keeping your system secure and up-to-date.

        `,
    },
    {
        subtitle: "Shell Scripting",
        text: `
            Learn shell scripting from basics to advanced automation. Covers script creation and execution, variables, conditionals, loops, and practical applications like backup scripts. Develop skills to automate repetitive tasks and create command-line tools. Includes hands-on projects and real-world examples.
        `,
    },

];

export const devopsModules = [
    {
        subtitle: "Filesystem hierarchy",
        text: `
            Unix has a unique filesystem structure which you may find very
            unusual if you come from Windows. You will learn about Filesystem
            Hierarchy Standard (FHS) and check out where you can find logs,
            configuration files, essential binaries, and libraries. You will
            also learn how to work with temporary files.
        `,
    },
    {
        subtitle: "Cron",
        text: `
            The crond daemon enables you to run programs at regular intervals.
            Much better than staying up late and running the programs manually.
            You will learn ins and outs of cron in this module.
        `,
    },
    {
        subtitle: "Systemd",
        text: `
            Systemd is an init system used to get your system up and running.
            You will learn how to start and stop processes, check logs, mount
            filesystems, enable programs to start when your system starts up,
            and other good stuff.
        `,
    },
    {
        subtitle: "Resource management",
        text: `
            Memory, CPU, and disk space are some of the essential resources
            an operating system manages. Learn resource monitoring with top,
            iostat, lsof, and other tools. By completing this module you will
            understand the resource utilization of your system and have the
            ability to identify resource consumption by processes.
        `,
    },
    {
        subtitle: "Filesystems",
        text: `
            There are multiple filesystem types used for different purposes.
            You will learn the differences between filesystems and concepts
            like inodes, mounts, and mount options. You will also create and
            mount temporary and memory-backed filesystems.
        `,
    },
    {
        subtitle: "Networking",
        text: `
            Learn how to configure networking on your system. You will learn
            about different kinds of network interfaces, how to configure network
            interfaces, how to set up custom hosts entries, change DNS resolver
            settings, and other networking-related operations.
        `,
    },
    {
        subtitle: "Firewall",
        text: `
            Linux comes with a very powerful kernel-based firewall called iptables.
            You will learn to allow, block or modify certain types of traffic which
            are essential skills to make your servers safe on the public internet.
        `,
    },
    {
        subtitle: "System calls",
        text: `
            System calls are a mechanism that programs use to interact with the
            kernel. Whenever a program wants to open and write to a file or
            perform any other operation with a kernel it makes a system call.
            You will learn how to track system calls in this module. It is a
            very useful troubleshooting technique.
        `,
    },
    {
        subtitle: "Network troubleshooting",
        text: `
            When something does not work on the network level you need to take
            a deep dive under the hood to figure out what is going on. In this
            module, you will learn how to track network packets, scan for open
            ports, test connectivity to remote machines using ping and telnet,
            and many more useful techniques that will be a valuable addition to
            your troubleshooting skills toolbox.
        `,
    },
    {
        subtitle: "Namespaces and cgroups",
        text: `
            These are the basic building blocks of modern container engines such
            as Docker. You will learn what namespaces are, and how to create a
            new or run a program in an existing namespace. You will also learn
            how to allocate resources such as CPU time, system memory, and network
            bandwidth to a process or a group of processes using cgroups.
        `,
    },
];
